import { Commands, Events, eventsManager, RenderCamera, SceneConstants } from '@rhinov/savane-js';
import { FiltersWidget } from '../FiltersWidget';
import { FilterGroup } from '../Tools/FilterGroup';
import { FiltersController } from '../Tools/FiltersController';
import { PlanManager } from '@rhinov/cocos-plan'

export class CamerasFilterWidget extends FilterGroup {
    camerasCount: number = 0;
    camerasWatcher: number | undefined;
    filterRefreshListener: any | null = null;

    constructor(container: string) {
        super();
        this.id = 'cameras';
        this.name = 'Caméras';
        this.icon = 'fas fa-lg fa-camera';
        this.resource = 'assets';
        this.container = container;
        this.controller = new FiltersController();
        this.filterRefreshListener = eventsManager.instance.addListener(Events.REFRESH_CURRENT_FILTER, () => { 
                                                                                                                                FiltersWidget.cacheCameras = [];
                                                                                                                                this.camerasUpdated();
                                                                                                                            });
    }

    static getInstance(): CamerasFilterWidget | null {
        if (!FiltersWidget.filterGroups || FiltersWidget.filterGroups.length === 0) return null;
        return FiltersWidget.filterGroups.find((filterGroup: FilterGroup) => filterGroup.id === 'cameras') as CamerasFilterWidget || null;
    }

    cameras() {
        if (FiltersWidget.cacheCameras.length === 0) {
            var instance = PlanManager.getInstance();
            if (!instance) {
                return [];
            }

            var cameras: RenderCamera[] = [];
            for (var i = 0; i < instance.scene.floors.length; ++i) {
                cameras = cameras.concat(instance.scene.floors[i].renderCameras);
            }

            cameras = cameras.sort((a: RenderCamera, b: RenderCamera) => a.cameraNb > b.cameraNb ? 1 : -1);

            var result = cameras.filter((a: RenderCamera) => a.cameraType === SceneConstants.CameraType.Perspective)
                .concat(cameras.filter((a: RenderCamera) => a.cameraType === SceneConstants.CameraType.Storage))
                .concat(cameras.filter((a: RenderCamera) => a.cameraType === SceneConstants.CameraType.Axonomic))
                .concat(cameras.filter((a: RenderCamera) => a.cameraType === SceneConstants.CameraType.Panoramic))
                .concat(cameras.filter((a: RenderCamera) => a.cameraType === SceneConstants.CameraType.PhotoRender))
                .concat(cameras.filter((a: RenderCamera) => a.cameraType === SceneConstants.CameraType.Video));

            FiltersWidget.cacheCameras = result;
        }

        this.camerasCount = FiltersWidget.cacheCameras.length;
        return FiltersWidget.cacheCameras;
    };

    static RenderAfters() {
        eventsManager.instance.dispatch(Events.COMPUTE_CAMERA_SHOPPING_LIST);
        eventsManager.instance.dispatch(Events.SAVE_SCENE);
        var cameras = PlanManager.getInstance()?.world?.currentScene?.renderCameras;
        if (cameras) {
            cameras = cameras.filter(function (camera: RenderCamera) {
                return camera.cameraType === SceneConstants.CameraType.Perspective ||
                    camera.cameraType === SceneConstants.CameraType.Storage ||
                    camera.cameraType === SceneConstants.CameraType.PhotoRender;
            });
            eventsManager.instance.dispatch(Events.RENDER_ALL, { cameras: cameras });
        }
    };

    static RenderPanos() {
        eventsManager.instance.dispatch(Events.SAVE_SCENE);
        var cameras = PlanManager.getInstance()?.world?.currentScene?.renderCameras;
        if (cameras) {
            cameras = cameras.filter(function (camera: RenderCamera) {
                return camera.cameraType === SceneConstants.CameraType.Panoramic;
            });
            eventsManager.instance.dispatch(Events.RENDER_ALL, { cameras: cameras });
        }
    };

    static RenderAxos() {
        eventsManager.instance.dispatch(Events.SAVE_SCENE);
        var cameras = PlanManager.getInstance()?.world?.currentScene?.renderCameras;
        if (cameras) {
            cameras = cameras.filter(function (camera: RenderCamera) {
                return camera.cameraType === SceneConstants.CameraType.Axonomic;
            });
            eventsManager.instance.dispatch(Events.RENDER_ALL, { cameras: cameras });
        }
    };

    static startLocalPreview() {
        switch (FilterGroup.previewCameraId) {
            // Free camera selected
            case -1:
                var freeCamera = FilterGroup.addFreeCameraToRhinovFormat();
                eventsManager.instance.dispatch("launchLocalRender", { camera_id: freeCamera.id });
                FilterGroup.removeFreeCameraFromRhinovFormat(freeCamera);
                break;

            // Other camera selected
            default:
                eventsManager.instance.dispatch("launchLocalRender", { camera_id: FilterGroup.previewCameraId });
        }
    };

    static setAllCamerasValue(name: any, value: any) {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        let cameras = FiltersWidget.cacheCameras;
        for (let i = 0; i < cameras.length; ++i) {
            cameras[i].startTemporary();
            cameras[i][name] = value;
            FiltersWidget.EmitEntityParamEditedEvent(cameras[i], name);
        }
        instance.executeCommand(new Commands.EditRenderCamerasCommand(cameras, true));
    }

    static cameraName(camera: RenderCamera) {
        switch (camera.cameraType) {
            case SceneConstants.CameraType.Perspective:
                return 'After ' + camera.cameraNb;
            case SceneConstants.CameraType.Storage:
                return 'Rangement ' + camera.cameraNb;
            case SceneConstants.CameraType.PhotoRender:
                return 'Photo ' + camera.cameraNb;
            case SceneConstants.CameraType.Panoramic:
                return 'Pano ' + camera.cameraNb;
            case SceneConstants.CameraType.Axonomic:
                return 'Axo ' + camera.cameraNb;
            case SceneConstants.CameraType.Video:
                return 'Video ' + camera.cameraNb;
        }
    };

    static cameraRenderTypeName(item: RenderCamera) {
        switch (item.renderType) {
            case 0:
                return "Inactif";
            case 1:
                return "Jour";
            case 2:
                return "Nuit";
            case 3:
                return "Jour + Nuit";
        }
    }

    static cameraFormat(item: RenderCamera) {
        switch (item.format) {
            case 0:
                return "Norm. pays.";
            case 1:
                return "Norm. port.";
            case 11:
                return "Norm. carré";
            case 13:
                return "Rang. pays.";
            case 14:
                return "Rang. port.";
            case 15:
                return "Cont. factory";
            case 16:
                return "Mark. 16:9";
            case 17:
                return "Mark. Inst.";
            case 18:
                return "Mark. vert.";
            case 9:
                return "Quizz - carré";
            case 10:
                return "Quizz - pays.";
            case 8:
                return "Libre";
        }
    }

    static cameraEditable(camera: RenderCamera) {
        switch (camera.cameraType) {
            case SceneConstants.CameraType.Perspective:
            case SceneConstants.CameraType.Storage:
            case SceneConstants.CameraType.Panoramic:
            case SceneConstants.CameraType.Axonomic:
            case SceneConstants.CameraType.Video:
                return true;
            case SceneConstants.CameraType.PhotoRender:
                return false;
        }
    };

    static cameraQualityName(item: RenderCamera) {
        switch (item.quality) {
            case 0:
                return "Uggly";
            case 1:
                return "Preview";
            case 2:
                return "Good";
            case 3:
                return "Great";
            case 4:
                return "Ultra";
            case 5:
                return "Bazooka";
        }
    }

    static renderCamera(camera: RenderCamera) {
        eventsManager.instance.dispatch(Events.COMPUTE_CAMERA_SHOPPING_LIST, camera.id);

        eventsManager.instance.dispatch(Events.SAVE_SCENE);

        eventsManager.instance.dispatch('launchRender', {
            camera_id: camera.id,
            quality: camera.quality,
            preview: false
        });
    };

    selectionListener?: () => void;

    camerasUpdated(): void {
        const camerasArray = this.cameras();
        const empty = camerasArray?.length === 0;
        $('#camerasTable').css('display', empty ? 'none' : '');
        $('#camerasControl').css('display', empty ? 'none' : 'flow-root');
        if (!empty) {
            this.updateCamerasHtml();
        }
    }

    html(): void {
        this.isDestroyed = false;
        this.selectionListener = () => { this.updateTitles(); };
        FilterGroup.addEntitySelectionListener(this.selectionListener);
        const camerasArray = this.cameras();
        let html = this.filtersHtml() + `
        <div>
            ${this.getCamerasRenderControlsHtml()}
            <div id="camerasTable" class="table-responsive" style="border-top: 1px solid rgb(115, 115, 115); ${(camerasArray?.length ?? 0) > 0 ? '' : 'display:none;'} padding-top: 5px;">
                <table class="table table-striped">
                    ${this.getCamerasTableHeaderHtml()}
                    <tbody id="cameras-tbody">
                    ${this.getCamerasHtml()}
                    </tbody>
                </table>
            </div>
            <div>
                ${this.getCamerasSettingsDropDownHtml()}
            </div>
            <div id="cameras-actions">
                ${this.getCamerasActionsHtml()}
            </div>
        </div>
        `;
        let container = document.getElementById(this.container);
        if (!container) {
            return;
        }
        container.innerHTML = html;
        this.camerasWatcher = setInterval(() => {
            let oldCount = this.camerasCount;
            let newCount = (this.cameras()?.length ?? 0);
            if (oldCount !== newCount) {
                this.updateCamerasHtml();
            }
        });
    }

    getCamerasRenderControlsHtml(): string {
        setTimeout(() => {
            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.RenderAfters();
            }, 'RenderAfters');

            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.RenderPanos();
            }, 'Panoramiques');

            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.RenderAxos();
            }, 'Axos');
        });
        return `
        <div id="camerasControl" style="display: ${(this.cameras()?.length ?? 0) > 0 ? 'flow-root' : 'none'}; padding-bottom: 5px;">
            <div style="padding-top: 5px; padding-bottom: 5px;">Lancer le rendu des cameras</div>
            <div class="col-sm-4">
                <button id="RenderAfters">Afters</button>
            </div>
            <div class="col-sm-4">
                <button id="Panoramiques">Panoramiques</button>
            </div>
            <div class="col-sm-4">
                <button id="Axos">Axos</button>
            </div>
        </div>
        `;
    }

    getCamerasTableHeaderHtml(): string {
        return `
        <thead>
            <tr>
                <th style="text-align: center;padding:4px">Nom</th>
                <th style="text-align: center;padding:4px">Num.</th>
                <th style="text-align: center;padding:4px">Format</th>
                <th style="text-align: center;padding:4px">Type rendu</th>
                <!--th style="text-align: center;padding:4px">HD</th-->
                <th style="text-align: center;padding:4px">Qualité</th>
                <th style="text-align: center;padding:4px">Haut.</th>
                <th style="text-align: center;padding:4px">Incl.</th>
            </tr>
        </thead>
        `;
    }

    updateCamerasHtml(): void {
        const tbody = document.getElementById('cameras-tbody');
        if (tbody) {
            const camerasArray = this.cameras();
            camerasArray?.forEach((_, index) => {
                //remove all listeners inside getCamerasSettingsDropDownHtml
                this.controller.removeEventListener('click', `camera-row-${index}`);
                this.controller.removeEventListener('change', `numCam-${index}`);
                this.controller.removeEventListener('click', `CamInactif-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamJour-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamNuit-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamJourNuit-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamUggly-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamPreview-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamGood-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamGreat-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamUltra-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamBazooka-${index}`, undefined, true);

                this.controller.removeEventListener('click', `CamNormalPaysage-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamNormalPortrait-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamNormalCarre-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamRangementPaysage-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamRangementPortrait-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamContentFactory-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamMarketing16-9-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamMarketingInstagram-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamMarketingVertical-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamQuizzCarre-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamQuizzPaysage-${index}`, undefined, true);
                this.controller.removeEventListener('click', `CamLibre-${index}`, undefined, true);

                this.controller.removeEventListener('change', `floorHeight-${index}`);
                this.controller.removeEventListener('change', `pitch-${index}`);
                this.controller.removeEventListener('click', `renderCamera-${index}`);
                this.controller.removeEventListener('click', `deleteEntity-${index}`);
            });
            tbody.innerHTML = this.getCamerasHtml();
        }
    }

    updateTitles() {
        $('.row-title').each((_index, element) => {
            $(element).prop('style', FilterGroup.isItemSelected(parseInt(element.id.split('-')[1])));
        });
    }

    getCamerasHtml(): string {
        return (this.cameras() ?? []).map((camera: RenderCamera, index: number) => {
            setTimeout(() => {
                this.controller.addEventListener('click', (ev) => {
                    FilterGroup.selectEntity(camera);
                    if (['TR', 'TD'].includes(ev.target.nodeName)) {
                        this.updateTitles();
                    }
                }, `camera-row-${index}`);

                this.controller.addEventListener('change', () => {
                    const inputValue = parseInt(($(`#numCam-${index}`).val() as string) ?? '', 10);
                    (FilterGroup.updateEntityProperty('cameraNb', camera) as any)(inputValue);
                    const refreshedValue = (FilterGroup.updateEntityProperty('cameraNb', camera) as any)(undefined) ?? '';
                    $(`#numCam-${index}`).val(refreshedValue);
                    this.updateCamerasHtml();
                }, `numCam-${index}`);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('format', camera, 0);
                    this.updateCamerasHtml();
                }, `CamNormalPaysage-${index}`, undefined, true);
                
                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('format', camera, 1);
                    this.updateCamerasHtml();
                }, `CamNormalPortrait-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('format', camera, 11);
                    this.updateCamerasHtml();
                }, `CamNormalCarre-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('format', camera, 13);
                    this.updateCamerasHtml();
                }, `CamRangementPaysage-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('format', camera, 14);
                    this.updateCamerasHtml();
                }, `CamRangementPortrait-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('format', camera, 15);
                    this.updateCamerasHtml();
                }, `CamContentFactory-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('format', camera, 16);
                    this.updateCamerasHtml();
                }, `CamMarketing16-9-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('format', camera, 17);
                    this.updateCamerasHtml();
                }, `CamMarketingInstagram-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('format', camera, 18);
                    this.updateCamerasHtml();
                }, `CamMarketingVertical-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('format', camera, 9);
                    this.updateCamerasHtml();
                }, `CamQuizzCarre-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('format', camera, 10);
                    this.updateCamerasHtml();
                }, `CamQuizzPaysage-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('format', camera, 8);
                    this.updateCamerasHtml();
                }, `CamLibre-${index}`, undefined, true);

                //#region Type de rendu Camera
                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('renderType', camera, 0);
                    this.updateCamerasHtml();
                }, `CamInactif-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('renderType', camera, 1);
                    this.updateCamerasHtml();
                }, `CamJour-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('renderType', camera, 2);
                    this.updateCamerasHtml();
                }, `CamNuit-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('renderType', camera, 3)
                    this.updateCamerasHtml();
                }, `CamJourNuit-${index}`, undefined, true);
                //#endregion
                //#region Qualité de rendu Camera
                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('quality', camera, 0)
                    this.updateCamerasHtml();
                }, `CamUggly-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('quality', camera, 1);
                    this.updateCamerasHtml();
                }, `CamPreview-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('quality', camera, 2);
                    this.updateCamerasHtml();
                }, `CamGood-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('quality', camera, 3);
                    this.updateCamerasHtml();
                }, `CamGreat-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('quality', camera, 4);
                    this.updateCamerasHtml();
                }, `CamUltra-${index}`, undefined, true);

                this.controller.addEventListener('click', () => {
                    FilterGroup.setDropdownValue('quality', camera, 5);
                    this.updateCamerasHtml();
                }, `CamBazooka-${index}`, undefined, true);
                //#endregion

                this.controller.addEventListener('change', () => {
                    const inputValue = parseInt(($(`#floorHeight-${index}`).val() as string) ?? '', 10);
                    (FilterGroup.updateEntityProperty('floorHeight', camera) as any)(inputValue);
                    const refreshedValue = (FilterGroup.updateEntityProperty('floorHeight', camera) as any)(undefined) ?? '';
                    $(`#floorHeight-${index}`).val(refreshedValue);
                    this.updateCamerasHtml();
                }, `floorHeight-${index}`);

                this.controller.addEventListener('change', () => {
                    const inputValue = parseInt(($(`#pitch-${index}`).val() as string) ?? '', 10);
                    (FilterGroup.updateEntityProperty('pitch', camera) as any)(inputValue);
                    const refreshedValue = (FilterGroup.updateEntityProperty('pitch', camera) as any)(undefined) ?? '';
                    $(`#pitch-${index}`).val(refreshedValue);
                    this.updateCamerasHtml();
                }, `pitch-${index}`);

                this.controller.addEventListener('click', () => {
                    CamerasFilterWidget.renderCamera(camera);
                }, `renderCamera-${index}`);

                this.controller.addEventListener('click', () => {
                    FilterGroup.deleteEntity(camera);
                    this.updateCamerasHtml();
                }, `deleteEntity-${index}`);
            });
            return `
            <tr id="camera-row-${index}">
                <td id="camera-${camera.id}" class="row-title" style="${FilterGroup.isItemSelected(camera.id)}">${CamerasFilterWidget.cameraName(camera)}</td>
                <td style="vertical-align: middle;width:40px;padding:4px">
                    <input id="numCam-${index}" style="width:40px" step="1" ${!CamerasFilterWidget.cameraEditable(camera) ? 'disabled' : ''}
                    type="number" value="${(FilterGroup.updateEntityProperty('cameraNb', camera) as any)(undefined) ?? ''}" />
                </td>
                <td style="vertical-align: middle;width:100px;padding:4px">
                    <div class="dropdown" style="width:100px">
                        <button class="btn btn-default dropdown-toggle" style="width:100px;padding: 5px !important;" type="button" id="dropdownMenu-camera-${camera.id}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                            ${CamerasFilterWidget.cameraFormat(camera)}
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu" style="width: auto !important;" aria-labelledby="dropdownMenu-camera-${camera.id}">
                            <li><a id="CamNormalPaysage-${index}">Norm. pays.</a></li>
                            <li><a id="CamNormalPortrait-${index}">Norm. port.</a></li>
                            <li><a id="CamNormalCarre-${index}">Norm. carré</a></li>
                            <li><a id="CamRangementPaysage-${index}">Rang. pays.</a></li>
                            <li><a id="CamRangementPortrait-${index}">Rang. port.</a></li>
                            <li><a id="CamContentFactory-${index}">Cont. Factory</a></li>
                            <li><a id="CamMarketing16-9-${index}">Mark. 16:9</a></li>
                            <li><a id="CamMarketingInstagram-${index}">Mark. Inst.</a></li>
                            <li><a id="CamMarketingVertical-${index}">Mark. vert.</a></li>
                            <li><a id="CamQuizzCarre-${index}">Quizz - carré</a></li>
                            <li><a id="CamQuizzPaysage-${index}">Quizz - pays.</a></li>
                            <li><a id="CamLibre-${index}">Libre</a></li>
                        </ul>
                    </div>
                </td>
                <td style="vertical-align: middle;width:80px;padding:4px">
                    <div class="dropdown" style="width:80px">
                        <button class="btn btn-default dropdown-toggle" style="width:80px;padding: 5px !important;" type="button" id="dropdownMenu-camera-${camera.id}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                            ${CamerasFilterWidget.cameraRenderTypeName(camera)}
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu" style="width: auto !important;" aria-labelledby="dropdownMenu-camera-${camera.id}">
                            <li><a id="CamInactif-${index}">Inactif</a></li>
                            <li><a id="CamJour-${index}">Jour</a></li>
                            <li><a id="CamNuit-${index}">Nuit</a></li>
                            <li><a id="CamJourNuit-${index}">Jour + Nuit</a></li>
                        </ul>
                    </div>
                </td>

                <td style="vertical-align: middle;width:80px;padding:4px">
                    <div class="dropdown" style="width:80px">
                        <button class="btn btn-default dropdown-toggle" style="width:80px;padding: 5px !important;" type="button" id="dropdownMenu-camera-quality-${camera.id}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                            ${CamerasFilterWidget.cameraQualityName(camera)}
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu" style="width: auto !important;" aria-labelledby="dropdownMenu-camera-quality-${camera.id}">
                            <li><a id="CamUggly-${index}">Uggly</a></li>
                            <li><a id="CamPreview-${index}">Preview</a></li>
                            <li><a id="CamGood-${index}">Good</a></li>
                            <li><a id="CamGreat-${index}">Great</a></li>
                            <li><a id="CamUltra-${index}">Ultra</a></li>
                            ${FiltersWidget.contentFactory ? `<li><a id="CamBazooka-${index}">Bazooka</a></li>` : ''}
                        </ul>
                    </div>
                </td>
                <td style="vertical-align: middle;width:54px;padding:4px">
                    <input id="floorHeight-${index}" style="width:54px" type="number" step="1" ${!CamerasFilterWidget.cameraEditable(camera) ? 'disabled' : ''}
                        value="${(FilterGroup.updateEntityProperty('floorHeight', camera) as any)(undefined) ?? ''}">
                </td>
                <td style="vertical-align: middle;width:54px;padding:4px">
                    <input id="pitch-${index}" style="width:54px" min="-90" max="90" step="1" ${!CamerasFilterWidget.cameraEditable(camera) ? 'disabled' : ''}
                        type="number" value="${(FilterGroup.updateEntityProperty('pitch', camera) as any)(undefined) ?? ''}"/>
                </td>
                ${FiltersWidget.decorationDoneAllowed() ? `
                <td id="renderCamera-${index}" title="Lancer rendu" style="vertical-align: middle; cursor: pointer;text-align: center;">
                <i class="far fa-lg fa-image"></i></td>
                ` : ''}
                <td id="deleteEntity-${index}" ${!CamerasFilterWidget.cameraEditable(camera) ? 'disabled' : ''}
                    style="vertical-align: middle;cursor: ${CamerasFilterWidget.cameraEditable(camera) ? 'pointer' : 'not-allowed'};"
                    title="Supprimer"><i class="far fa-lg fa-trash-alt"></i></td>
            </tr>
            `;
        }).join('');
    }

    getCamerasSettingsDropDownHtml(): string {
        setTimeout(() => {
            //#region Type de rendu Cameras
            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.setAllCamerasValue('renderType', 0);
                this.updateCamerasHtml();
            }, 'AllCamInactif', undefined, true);

            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.setAllCamerasValue('renderType', 1);
                this.updateCamerasHtml();
            }, 'AllCamJour', undefined, true);

            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.setAllCamerasValue('renderType', 2);
                this.updateCamerasHtml();
            }, 'AllCamNuit', undefined, true);

            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.setAllCamerasValue('renderType', 3);
                this.updateCamerasHtml();
            }, 'AllCamJourNuit', undefined, true);
            //#endregion
            //#region Qualité de rendu Cameras
            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.setAllCamerasValue('quality', 0);
                this.updateCamerasHtml();
            }, 'AllCamUggly', undefined, true);

            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.setAllCamerasValue('quality', 1);
                this.updateCamerasHtml();
            }, 'AllCamPreview', undefined, true);

            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.setAllCamerasValue('quality', 2);
                this.updateCamerasHtml();
            }, 'AllCamGood', undefined, true);

            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.setAllCamerasValue('quality', 3);
                this.updateCamerasHtml();
            }, 'AllCamGreat', undefined, true);

            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.setAllCamerasValue('quality', 4);
                this.updateCamerasHtml();
            }, 'AllCamUltra', undefined, true);

            this.controller.addEventListener('click', () => {
                CamerasFilterWidget.setAllCamerasValue('quality', 5);
                this.updateCamerasHtml();
            }, 'AllCamBazooka', undefined, true);
            //#endregion
        });
        return `
        <div style="border-top: 1px solid rgb(115, 115, 115); padding-top: 5px; padding-bottom: 5px;">Modifier toutes les cameras</div>
        <div class="dropdown col-sm-6">
            <div>
                <button class="btn btn-default dropdown-toggle" style="padding: 5px !important;" type="button" id="dropdownMenu-all-camera" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    Type de rendu
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu-all-camera">
                    <li><a id="AllCamInactif">Inactif</a></li>
                    <li><a id="AllCamJour">Jour</a></li>
                    <li><a id="AllCamNuit">Nuit</a></li>
                    <li><a id="AllCamJourNuit">Jour + Nuit</a></li>
                </ul>
            </div>
        </div>
        <div class="dropdown col-sm-6">
            <div>
                <button class="btn btn-default dropdown-toggle" style="padding: 5px !important;" type="button" id="dropdownMenu-all-camera-quality" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    Qualité de rendu
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu-all-camera-quality">
                    <li><a id="AllCamUggly">Uggly</a></li>
                    <li><a id="AllCamPreview">Preview</a></li>
                    <li><a id="AllCamGood">Good</a></li>
                    <li><a id="AllCamGreat">Great</a></li>
                    <li><a id="AllCamUltra">Ultra</a></li>
                    ${FiltersWidget.contentFactory ? `<li><a id="AllCamBazooka">Bazooka</a></li>` : ''}
                </ul>
            </div>
        </div>
        <div style="border-bottom: 1px solid rgb(115, 115, 115); padding-bottom: 5px; clear: both;"></div>
        `;
    }

    updateCamerasActionsHtml(): void {
        const container = document.getElementById('cameras-actions');
        if (container) {
            this.controller.removeEventListener('mousedown', 'addCamera');
            this.controller.removeEventListener('mousedown', 'ActiverPreviewAuto');
            this.controller.removeEventListener('mousedown', 'DesactiverPreviewAuto');
            this.controller.removeEventListener('mousedown', 'LocalPreview');
            container.innerHTML = this.getCamerasActionsHtml();
        }
    }

    getCamerasActionsHtml(): string {
        setTimeout(() => {
            this.controller.addEventListener('mousedown', () => {
                FiltersWidget.sendEvent('clickOnCamera');
                this.updateCamerasHtml();
            }, 'addCamera');

            this.controller.addEventListener('mousedown', () => {
                FilterGroup.startStopPreviewAuto();
                this.updateCamerasActionsHtml();
            }, 'ActiverPreviewAuto');

            this.controller.addEventListener('mousedown', () => {
                FilterGroup.startStopPreviewAuto();
                this.updateCamerasActionsHtml();
            }, 'DesactiverPreviewAuto');

            this.controller.addEventListener('mousedown', () => {
                CamerasFilterWidget.startLocalPreview();
            }, 'LocalPreview');
        });
        return `
        <button id="addCamera" class="btn-default" ${!FiltersWidget.enable_additionals_afters ? 'style= "display: none;"' : ''} title="Ajouter caméra">
            <i class="fas fa-lg fa-camera"></i>
            <span style="margin-left: 10px;margin-right: 50px">Ajouter camera</span>
        </button>

        ${!FilterGroup.previewAuto ? `
        <button id="ActiverPreviewAuto" class="btn-default" title="Activer preview auto">
            <i class="fas fa-lg fa-eye-slash"></i>
            <span style="margin-left: 10px;">Activer preview auto</span>
        </button>
        ` : ''}

        ${FilterGroup.previewAuto ? `
        <button id="DesactiverPreviewAuto" class="btn-default" title="Désactiver preview auto">
            <i class="fas fa-lg fa-eye"></i>
            <span style="margin-left: 10px;">Désactiver preview auto</span>
        </button>
        ` : ''}

        <button id="LocalPreview" class="btn-default" title="Lancer une preview locale">
            <i class="fas fa-lg fa-computer"></i>
            <span style="margin-left: 10px;">Preview locale</span>
        </button>
        `;
    }

    destroy(): void {
        super.destroy();
        if (this.selectionListener) {
            FilterGroup.removeEntitySelectionListener(this.selectionListener);
        }
        this.selectionListener = undefined;

        if (this.camerasWatcher) {
            clearInterval(this.camerasWatcher);
        }

        if (this.filterRefreshListener) {
            eventsManager.instance.removeListener(this.filterRefreshListener);
        }
    }
}